import * as endpoints from './APIEndpoints';
import {appStore} from './AppStore';
import {action, observable} from 'mobx';
import {message,Icon} from 'antd';
import {booleanAsString, toUrlParams} from "./Util";
import {dateColProps} from "../components/AggridHelper";
import cmFormDefs from './formFields/CmLooseDashbordForm';
import editorFormDefs from './formFields/CmLooseDashbordForm';
import pmFormDefs from './formFields/PmLooseleafForm';
import LooseLeafStore from './LooseLeafStore';
import copy from '../images/copy.png'
import moment from "moment";
import newgenlogo from "../../src/images/newgenlogo.png";

class DashboardArbitratorStore {
    apiProxy = null;

    constructor() {
        this.apiProxy = appStore.apiProxy;
    }

    @observable activeTab = '0';
    @observable getCountryName = '';

    @observable activeFilter = 'all';
    @observable currentTable = '';
    @observable currentData = {};

    @observable drawerVisible = false;

    @observable rowData = [];
    @observable summaryData = [];

    @observable loading = false;

    @observable selectedApprevation = '';

    @action setLoading = (loading) => {
        this.loading = loading;
    };
    defaultColDef= {
        sortable: true,
        resizable: true,
        filter: true,
      }

    cmColumns = [
        {headerName: "Row", field:'rowno'},
        // {headerName: "Product Type", field:'productType',
        // valueGetter: ({ data }) => {
        //     if (!data) return '';
        //     return data.productType == 'arbitrator_profile' ? 'Arbitrator Profile' : '-';
        //     },
        // },
        {headerName: 'Document Title', field:'classification'},
        {
            headerName: "Interest & Permission",
            columnGroupShow: 'open',
            children: [
        {headerName: 'Status', field: 'INTEREST_PERMISSION_STATUS'},
        {headerName: 'Date', field: 'INTEREST_PERMISSION_DATE',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {INTEREST_PERMISSION_DATE} = data;
            if (!INTEREST_PERMISSION_DATE) return '-';
           // var utcTime =  moment(INTEREST_PERMISSION_DATE).utc().format('LLL');
            var localTime  = moment.utc(INTEREST_PERMISSION_DATE).toDate();
            return moment(localTime).format('YYYY-MM-DD');
        }
        },
        ]},
        {headerName: 'Interest Request', field: 'INTEREST_REQUEST',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {INTEREST_REQUEST} = data;
            if (!INTEREST_REQUEST) return '-';
            return moment(INTEREST_REQUEST).format('YYYY-MM-DD');
        }
        },
        {headerName: 'Work Request', field:'WORK_REQUEST',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {WORK_REQUEST} = data;
            if (!WORK_REQUEST) return '-';
            return moment(WORK_REQUEST).format('YYYY-MM-DD');
        }
        },
        {headerName: 'Deadline (Freelancer)', field: 'DEADLINE_FREELANCER',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {DEADLINE_FREELANCER} = data;
            if (!DEADLINE_FREELANCER) return '-';
            return moment(DEADLINE_FREELANCER).format('YYYY-MM-DD');
        }
        },
        {headerName: 'Profile Received', field: 'PROFILE_RECEIVED',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {PROFILE_RECEIVED} = data;
            if (!PROFILE_RECEIVED) return '-';
            return moment(PROFILE_RECEIVED).format('YYYY-MM-DD');
        }
        },
        {headerName: 'Permission Request', field: 'PERMISSION_REQUEST',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {PERMISSION_REQUEST} = data;
            if (!PERMISSION_REQUEST) return '-';
            return moment(PERMISSION_REQUEST).format('YYYY-MM-DD');
        }
        },
        {headerName: 'Deadline (Arbitrator)', field: 'DEADLINE_ARBITRATOR',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {DEADLINE_ARBITRATOR} = data;
            if (!DEADLINE_ARBITRATOR) return '-';
            return moment(DEADLINE_ARBITRATOR).format('YYYY-MM-DD');
        }
        },
        {headerName: 'Profile Approved', field: 'PROFILE_APPROVED',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {PROFILE_APPROVED} = data;
            if (!PROFILE_APPROVED) return '-';
            return moment(PROFILE_APPROVED).format('YYYY-MM-DD');
        }
        },
        {headerName: 'Status', field: 'STATUS'},
        {headerName: 'Planned Date', field: 'projectStartDate'},
        {headerName: 'Project Start Date', field: 'projectStartDate'},
        {headerName: 'Freelancer Chase Date', field: 'freelancerChaseDate'},
        {
            headerName: "Reminder",
            columnGroupShow: 'open',
            children: [
        {headerName: 'Reminder', field: 'ARBITRATOR_REMINDER'},
        {headerName: 'Sent On', field: 'ARBITRATOR_REMINDER_AT',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {ARBITRATOR_REMINDER_AT} = data;
            if (!ARBITRATOR_REMINDER_AT) return '-';
            return moment(ARBITRATOR_REMINDER_AT).format('YYYY-MM-DD');
        }
        },
        ]},
        // {
        //     headerName: "Freelancer's Last Reminder",
        //     columnGroupShow: 'open',
        //     children: [
        // {headerName: 'Reminder', field: 'FREELANCER_REMINDER'},
        // {headerName: 'Sent On', field: 'FREELANCER_REMINDER_AT',
        // valueGetter: ({data}) => {
        //     if (!data) return '';
        //     const {FREELANCER_REMINDER_AT} = data;
        //     if (!FREELANCER_REMINDER_AT) return '-';
        //     return moment(FREELANCER_REMINDER_AT).format('YYYY-MM-DD');
        // }
        // },
        // ]},
        {
            headerName: 'Others Info',
            children: [
        {headerName: 'Notes 1', field: 'notes'},
        {headerName: 'Notes 2', field: 'note1'},
        {headerName: 'Notes 3', field: 'note2'},
        {headerName: 'Comments', field: 'comments'},
        //{headerName: 'Author Query', field: 'authorQuery'},
        // {headerName: 'Profile Approved Mail Sent', field: 'profile_approved_mail_sent_at',
        // valueGetter: ({data}) => {
        //     if (!data) return '';
        //     const {profile_approved_mail_sent_at} = data;
        //     if (!profile_approved_mail_sent_at) return '-';
        //     return moment(profile_approved_mail_sent_at).format('YYYY-MM-DD');
        // }},
        {headerName: 'Workflow', field: 'GLOBAL_WORKFLOW_NAME', columnGroupShow: 'open'},
        {headerName: 'Vendor', field: 'vendor', columnGroupShow: 'open',
        // valueGetter: ({ data }) => {
        //     if (!data) return '';
        //     return data.vendor == 'PubKit' ? 'PubKit' : 'LAPS';
        //     },
        },
        // {headerName: 'Laps Id', field: 'lapsId', columnGroupShow: 'open'},
        // {headerName: 'Laps Message', field: 'lapsMessage', columnGroupShow: 'open'},
        {headerName: 'Arbitrator', field: 'authorNames', columnGroupShow: 'open'},
        {headerName: 'Arbitrator Email', field: 'authorEmails', columnGroupShow: 'open'},
        {headerName: 'CM', field: 'cmNames', columnGroupShow: 'open'},
        {headerName: 'CM Email', field: 'cmEmails', columnGroupShow: 'open'},
        {headerName: 'Freelancer', field: 'freelancerNames', columnGroupShow: 'open'},
        {headerName: 'Freelancer Email', field: 'freelancerEmails', columnGroupShow: 'open'},
        //{headerName: 'Recycle Period', field: 'recyclePeriod', columnGroupShow: 'open'},
       
    ]},
       
     ];
     awaitingColumns = [
        {headerName: "Row", field:'rowno'},
        // {headerName: "Product Type", field:'productType',
        // valueGetter: ({ data }) => {
        //     if (!data) return '';
        //     return data.productType == 'arbitrator_profile' ? 'Arbitrator Profile' : '-';
        //     },
        // },
        {headerName: 'Document Title', field:'classification'},
        {
            headerName: "Interest & Permission",
            columnGroupShow: 'open',
            children: [
        {headerName: 'Status', field: 'INTEREST_PERMISSION_STATUS'},
        {headerName: 'Date', field: 'INTEREST_PERMISSION_DATE',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {INTEREST_PERMISSION_DATE} = data;
            if (!INTEREST_PERMISSION_DATE) return '-';
           // var utcTime =  moment(INTEREST_PERMISSION_DATE).utc().format('LLL');
            var localTime  = moment.utc(INTEREST_PERMISSION_DATE).toDate();
            return moment(localTime).format('YYYY-MM-DD');
        }
        },
        ]},
        {headerName: 'Interest Request', field: 'INTEREST_REQUEST',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {INTEREST_REQUEST} = data;
            if (!INTEREST_REQUEST) return '-';
            return moment(INTEREST_REQUEST).format('YYYY-MM-DD');
        }
        },
        {headerName: 'Work Request', field:'WORK_REQUEST',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {WORK_REQUEST} = data;
            if (!WORK_REQUEST) return '-';
            return moment(WORK_REQUEST).format('YYYY-MM-DD');
        }
        },
        {headerName: 'Deadline (Freelancer)', field: 'DEADLINE_FREELANCER',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {DEADLINE_FREELANCER} = data;
            if (!DEADLINE_FREELANCER) return '-';
            return moment(DEADLINE_FREELANCER).format('YYYY-MM-DD');
        }
        },
        {headerName: 'Profile Received', field: 'PROFILE_RECEIVED',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {PROFILE_RECEIVED} = data;
            if (!PROFILE_RECEIVED) return '-';
            return moment(PROFILE_RECEIVED).format('YYYY-MM-DD');
        }
        },
        {headerName: 'Permission Request', field: 'PERMISSION_REQUEST',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {PERMISSION_REQUEST} = data;
            if (!PERMISSION_REQUEST) return '-';
            return moment(PERMISSION_REQUEST).format('YYYY-MM-DD');
        }
        },
        {headerName: 'Deadline (Arbitrator)', field: 'DEADLINE_ARBITRATOR',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {DEADLINE_ARBITRATOR} = data;
            if (!DEADLINE_ARBITRATOR) return '-';
            return moment(DEADLINE_ARBITRATOR).format('YYYY-MM-DD');
        }
        },
        {headerName: 'Profile Approved', field: 'PROFILE_APPROVED',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {PROFILE_APPROVED} = data;
            if (!PROFILE_APPROVED) return '-';
            return moment(PROFILE_APPROVED).format('YYYY-MM-DD');
        }
        },
        {headerName: 'Status', field: 'STATUS'},
        {headerName: 'Planned Date', field: 'projectStartDate'},
        {headerName: 'Project Start Date', field: 'projectStartDate', valueGetter: (params)=> {
            if(!params.data) return null
            if(params.data["projectId"] == null || params.data["projectId"] < 0) return null
        }},
        {headerName: 'Freelancer Chase Date', field: 'freelancerChaseDate'},
        {
            headerName: "Reminder",
            columnGroupShow: 'open',
            children: [
        {headerName: 'Reminder', field: 'ARBITRATOR_REMINDER'},
        {headerName: 'Sent On', field: 'ARBITRATOR_REMINDER_AT',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {ARBITRATOR_REMINDER_AT} = data;
            if (!ARBITRATOR_REMINDER_AT) return '-';
            return moment(ARBITRATOR_REMINDER_AT).format('YYYY-MM-DD');
        }
        },
        ]},
        // {
        //     headerName: "Freelancer's Last Reminder",
        //     columnGroupShow: 'open',
        //     children: [
        // {headerName: 'Reminder', field: 'FREELANCER_REMINDER'},
        // {headerName: 'Sent On', field: 'FREELANCER_REMINDER_AT',
        // valueGetter: ({data}) => {
        //     if (!data) return '';
        //     const {FREELANCER_REMINDER_AT} = data;
        //     if (!FREELANCER_REMINDER_AT) return '-';
        //     return moment(FREELANCER_REMINDER_AT).format('YYYY-MM-DD');
        // }
        // },
        // ]},
        {
            headerName: 'Others Info',
            children: [
        {headerName: 'Notes 1', field: 'notes'},
        {headerName: 'Notes 2', field: 'note1'},
        {headerName: 'Notes 3', field: 'note2'},
        // {headerName: 'Profile Approved Mail Sent', field: 'profile_approved_mail_sent_at',
        // valueGetter: ({data}) => {
        //     if (!data) return '';
        //     const {profile_approved_mail_sent_at} = data;
        //     if (!profile_approved_mail_sent_at) return '-';
        //     return moment(profile_approved_mail_sent_at).format('YYYY-MM-DD');
        // }},
        {headerName: 'Workflow', field: 'GLOBAL_WORKFLOW_NAME', columnGroupShow: 'open'},
        {headerName: 'Vendor', field: 'vendor', columnGroupShow: 'open',
        // valueGetter: ({ data }) => {
        //     if (!data) return '';
        //     return data.vendor == 'PubKit' ? 'PubKit' : 'LAPS';
        //     },
        },
        // {headerName: 'Laps Id', field: 'lapsId', columnGroupShow: 'open'},
        // {headerName: 'Laps Message', field: 'lapsMessage', columnGroupShow: 'open'},
        {headerName: 'Arbitrator', field: 'authorNames', columnGroupShow: 'open'},
        {headerName: 'Arbitrator Email', field: 'authorEmails', columnGroupShow: 'open'},
        {headerName: 'CM', field: 'cmNames', columnGroupShow: 'open'},
        {headerName: 'CM Email', field: 'cmEmails', columnGroupShow: 'open'},
        {headerName: 'Freelancer', field: 'freelancerNames', columnGroupShow: 'open'},
        {headerName: 'Freelancer Email', field: 'freelancerEmails', columnGroupShow: 'open'},
        //{headerName: 'Recycle Period', field: 'recyclePeriod', columnGroupShow: 'open'},
       
    ]},
     ];
     plannedColumns = [
        {headerName: "Row", field:'rowno'},
        // {headerName: "Product Type", field:'productType',
        // valueGetter: ({ data }) => {
        //     if (!data) return '';
        //     return data.productType == 'arbitrator_profile' ? 'Arbitrator Profile' : '-';
        //     },
        // },
        {headerName: 'Document Title', field:'classification'},
        {
            headerName: "Interest & Permission",
            columnGroupShow: 'open',
            children: [
        {headerName: 'Status', field: 'INTEREST_PERMISSION_STATUS'},
        {headerName: 'Date', field: 'INTEREST_PERMISSION_DATE',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {INTEREST_PERMISSION_DATE} = data;
            if (!INTEREST_PERMISSION_DATE) return '-';
           // var utcTime =  moment(INTEREST_PERMISSION_DATE).utc().format('LLL');
            var localTime  = moment.utc(INTEREST_PERMISSION_DATE).toDate();
            return moment(localTime).format('YYYY-MM-DD');
        }
        },
        ]},
        {headerName: 'Interest Request', field: 'INTEREST_REQUEST',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {INTEREST_REQUEST} = data;
            if (!INTEREST_REQUEST) return '-';
            return moment(INTEREST_REQUEST).format('YYYY-MM-DD');
        }
        },
        {headerName: 'Work Request', field:'WORK_REQUEST',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {WORK_REQUEST} = data;
            if (!WORK_REQUEST) return '-';
            return moment(WORK_REQUEST).format('YYYY-MM-DD');
        }
        },
        {headerName: 'Deadline (Freelancer)', field: 'DEADLINE_FREELANCER',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {DEADLINE_FREELANCER} = data;
            if (!DEADLINE_FREELANCER) return '-';
            return moment(DEADLINE_FREELANCER).format('YYYY-MM-DD');
        }
        },
        {headerName: 'Profile Received', field: 'PROFILE_RECEIVED',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {PROFILE_RECEIVED} = data;
            if (!PROFILE_RECEIVED) return '-';
            return moment(PROFILE_RECEIVED).format('YYYY-MM-DD');
        }
        },
        {headerName: 'Permission Request', field: 'PERMISSION_REQUEST',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {PERMISSION_REQUEST} = data;
            if (!PERMISSION_REQUEST) return '-';
            return moment(PERMISSION_REQUEST).format('YYYY-MM-DD');
        }
        },
        {headerName: 'Deadline (Arbitrator)', field: 'DEADLINE_ARBITRATOR',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {DEADLINE_ARBITRATOR} = data;
            if (!DEADLINE_ARBITRATOR) return '-';
            return moment(DEADLINE_ARBITRATOR).format('YYYY-MM-DD');
        }
        },
        {headerName: 'Profile Approved', field: 'PROFILE_APPROVED',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {PROFILE_APPROVED} = data;
            if (!PROFILE_APPROVED) return '-';
            return moment(PROFILE_APPROVED).format('YYYY-MM-DD');
        }
        },
        {headerName: 'Status', field: 'STATUS'},
        {headerName: 'Planned Date', field: 'projectStartDate'},
        {headerName: 'Project Start Date', field: 'projectStartDate'},
        {headerName: 'Freelancer Chase Date', field: 'freelancerChaseDate'},
        {
            headerName: "Reminder",
            columnGroupShow: 'open',
            children: [
        {headerName: 'Reminder', field: 'ARBITRATOR_REMINDER'},
        {headerName: 'Sent On', field: 'ARBITRATOR_REMINDER_AT',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {ARBITRATOR_REMINDER_AT} = data;
            if (!ARBITRATOR_REMINDER_AT) return '-';
            return moment(ARBITRATOR_REMINDER_AT).format('YYYY-MM-DD');
        }
        },
        ]},
        // {
        //     headerName: "Freelancer's Last Reminder",
        //     columnGroupShow: 'open',
        //     children: [
        // {headerName: 'Reminder', field: 'FREELANCER_REMINDER'},
        // {headerName: 'Sent On', field: 'FREELANCER_REMINDER_AT',
        // valueGetter: ({data}) => {
        //     if (!data) return '';
        //     const {FREELANCER_REMINDER_AT} = data;
        //     if (!FREELANCER_REMINDER_AT) return '-';
        //     return moment(FREELANCER_REMINDER_AT).format('YYYY-MM-DD');
        // }
        // },
        // ]},
        {
            headerName: 'Others Info',
            children: [
        {headerName: 'Notes 1', field: 'notes'},
        {headerName: 'Notes 2', field: 'note1'},
        {headerName: 'Notes 3', field: 'note2'},
        // {headerName: 'Profile Approved Mail Sent', field: 'profile_approved_mail_sent_at',
        // valueGetter: ({data}) => {
        //     if (!data) return '';
        //     const {profile_approved_mail_sent_at} = data;
        //     if (!profile_approved_mail_sent_at) return '-';
        //     return moment(profile_approved_mail_sent_at).format('YYYY-MM-DD');
        // }},
        {headerName: 'Workflow', field: 'GLOBAL_WORKFLOW_NAME', columnGroupShow: 'open'},
        {headerName: 'Vendor', field: 'vendor', columnGroupShow: 'open',
        // valueGetter: ({ data }) => {
        //     if (!data) return '';
        //     return data.vendor == 'PubKit' ? 'PubKit' : 'LAPS';
        //     },
        },
        // {headerName: 'Laps Id', field: 'lapsId', columnGroupShow: 'open'},
        // {headerName: 'Laps Message', field: 'lapsMessage', columnGroupShow: 'open'},
        {headerName: 'Arbitrator', field: 'authorNames', columnGroupShow: 'open'},
        {headerName: 'Arbitrator Email', field: 'authorEmails', columnGroupShow: 'open'},
        {headerName: 'CM', field: 'cmNames', columnGroupShow: 'open'},
        {headerName: 'CM Email', field: 'cmEmails', columnGroupShow: 'open'},
        {headerName: 'Freelancer', field: 'freelancerNames', columnGroupShow: 'open'},
        {headerName: 'Freelancer Email', field: 'freelancerEmails', columnGroupShow: 'open'},
        //{headerName: 'Recycle Period', field: 'recyclePeriod', columnGroupShow: 'open'},
       
    ]},
     ];
     inColumns = [
        {headerName: "Row", field:'rowno'},
        // {headerName: "Product Type", field:'productType',
        // valueGetter: ({ data }) => {
        //     if (!data) return '';
        //     return data.productType == 'arbitrator_profile' ? 'Arbitrator Profile' : '-';
        //     },
        // },
        {headerName: 'Document Title', field:'classification'},
        {
            headerName: "Interest & Permission",
            columnGroupShow: 'open',
            children: [
        {headerName: 'Status', field: 'INTEREST_PERMISSION_STATUS'},
        {headerName: 'Date', field: 'INTEREST_PERMISSION_DATE',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {INTEREST_PERMISSION_DATE} = data;
            if (!INTEREST_PERMISSION_DATE) return '-';
           // var utcTime =  moment(INTEREST_PERMISSION_DATE).utc().format('LLL');
            var localTime  = moment.utc(INTEREST_PERMISSION_DATE).toDate();
            return moment(localTime).format('YYYY-MM-DD');
        }
        },
        ]},
        {headerName: 'Interest Request', field: 'INTEREST_REQUEST',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {INTEREST_REQUEST} = data;
            if (!INTEREST_REQUEST) return '-';
            return moment(INTEREST_REQUEST).format('YYYY-MM-DD');
        }
        },
        {headerName: 'Work Request', field:'WORK_REQUEST',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {WORK_REQUEST} = data;
            if (!WORK_REQUEST) return '-';
            return moment(WORK_REQUEST).format('YYYY-MM-DD');
        }
        },
        {headerName: 'Deadline (Freelancer)', field: 'DEADLINE_FREELANCER',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {DEADLINE_FREELANCER} = data;
            if (!DEADLINE_FREELANCER) return '-';
            return moment(DEADLINE_FREELANCER).format('YYYY-MM-DD');
        }
        },
        {headerName: 'Profile Received', field: 'PROFILE_RECEIVED',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {PROFILE_RECEIVED} = data;
            if (!PROFILE_RECEIVED) return '-';
            return moment(PROFILE_RECEIVED).format('YYYY-MM-DD');
        }
        },
        {headerName: 'Permission Request', field: 'PERMISSION_REQUEST',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {PERMISSION_REQUEST} = data;
            if (!PERMISSION_REQUEST) return '-';
            return moment(PERMISSION_REQUEST).format('YYYY-MM-DD');
        }
        },
        {headerName: 'Deadline (Arbitrator)', field: 'DEADLINE_ARBITRATOR',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {DEADLINE_ARBITRATOR} = data;
            if (!DEADLINE_ARBITRATOR) return '-';
            return moment(DEADLINE_ARBITRATOR).format('YYYY-MM-DD');
        }
        },
        {headerName: 'Profile Approved', field: 'PROFILE_APPROVED',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {PROFILE_APPROVED} = data;
            if (!PROFILE_APPROVED) return '-';
            return moment(PROFILE_APPROVED).format('YYYY-MM-DD');
        }
        },
        {headerName: 'Status', field: 'STATUS'},
        {headerName: 'Planned Date', field: 'projectStartDate'},
        {headerName: 'Project Start Date', field: 'projectStartDate'},
        {headerName: 'Freelancer Chase Date', field: 'freelancerChaseDate'},
        {
            headerName: "Reminder",
            columnGroupShow: 'open',
            children: [
        {headerName: 'Reminder', field: 'ARBITRATOR_REMINDER'},
        {headerName: 'Sent On', field: 'ARBITRATOR_REMINDER_AT',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {ARBITRATOR_REMINDER_AT} = data;
            if (!ARBITRATOR_REMINDER_AT) return '-';
            return moment(ARBITRATOR_REMINDER_AT).format('YYYY-MM-DD');
        }
        },
        ]},
        // {
        //     headerName: "Freelancer's Last Reminder",
        //     columnGroupShow: 'open',
        //     children: [
        // {headerName: 'Reminder', field: 'FREELANCER_REMINDER'},
        // {headerName: 'Sent On', field: 'FREELANCER_REMINDER_AT',
        // valueGetter: ({data}) => {
        //     if (!data) return '';
        //     const {FREELANCER_REMINDER_AT} = data;
        //     if (!FREELANCER_REMINDER_AT) return '-';
        //     return moment(FREELANCER_REMINDER_AT).format('YYYY-MM-DD');
        // }
        // },
        // ]},
        {
            headerName: 'Others Info',
            children: [
        {headerName: 'Notes 1', field: 'notes'},
        {headerName: 'Notes 2', field: 'note1'},
        {headerName: 'Notes 3', field: 'note2'},
        // {headerName: 'Profile Approved Mail Sent', field: 'profile_approved_mail_sent_at',
        // valueGetter: ({data}) => {
        //     if (!data) return '';
        //     const {profile_approved_mail_sent_at} = data;
        //     if (!profile_approved_mail_sent_at) return '-';
        //     return moment(profile_approved_mail_sent_at).format('YYYY-MM-DD');
        // }},
        {headerName: 'Workflow', field: 'GLOBAL_WORKFLOW_NAME', columnGroupShow: 'open'},
        {headerName: 'Vendor', field: 'vendor', columnGroupShow: 'open',
        // valueGetter: ({ data }) => {
        //     if (!data) return '';
        //     return data.vendor == 'PubKit' ? 'PubKit' : 'LAPS';
        //     },
        },
        // {headerName: 'Laps Id', field: 'lapsId', columnGroupShow: 'open'},
        // {headerName: 'Laps Message', field: 'lapsMessage', columnGroupShow: 'open'},
        {headerName: 'Arbitrator', field: 'authorNames', columnGroupShow: 'open'},
        {headerName: 'Arbitrator Email', field: 'authorEmails', columnGroupShow: 'open'},
        {headerName: 'CM', field: 'cmNames', columnGroupShow: 'open'},
        {headerName: 'CM Email', field: 'cmEmails', columnGroupShow: 'open'},
        {headerName: 'Freelancer', field: 'freelancerNames', columnGroupShow: 'open'},
        {headerName: 'Freelancer Email', field: 'freelancerEmails', columnGroupShow: 'open'},
        //{headerName: 'Recycle Period', field: 'recyclePeriod', columnGroupShow: 'open'},
       
    ]},
     ];
     doNotChaseColumns = [
        {headerName: "Row", field:'rowno'},
        // {headerName: "Product Type", field:'productType',
        // valueGetter: ({ data }) => {
        //     if (!data) return '';
        //     return data.productType == 'arbitrator_profile' ? 'Arbitrator Profile' : '-';
        //     },
        // },
        {headerName: 'Document Title', field:'classification'},
        {
            headerName: "Interest & Permission",
            columnGroupShow: 'open',
            children: [
        {headerName: 'Status', field: 'INTEREST_PERMISSION_STATUS'},
        {headerName: 'Date', field: 'INTEREST_PERMISSION_DATE',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {INTEREST_PERMISSION_DATE} = data;
            if (!INTEREST_PERMISSION_DATE) return '-';
           // var utcTime =  moment(INTEREST_PERMISSION_DATE).utc().format('LLL');
            var localTime  = moment.utc(INTEREST_PERMISSION_DATE).toDate();
            return moment(localTime).format('YYYY-MM-DD');
        }
        },
        ]},
        {headerName: 'Interest Request', field: 'INTEREST_REQUEST',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {INTEREST_REQUEST} = data;
            if (!INTEREST_REQUEST) return '-';
            return moment(INTEREST_REQUEST).format('YYYY-MM-DD');
        }
        },
        {headerName: 'Work Request', field:'WORK_REQUEST',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {WORK_REQUEST} = data;
            if (!WORK_REQUEST) return '-';
            return moment(WORK_REQUEST).format('YYYY-MM-DD');
        }
        },
        {headerName: 'Deadline (Freelancer)', field: 'DEADLINE_FREELANCER',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {DEADLINE_FREELANCER} = data;
            if (!DEADLINE_FREELANCER) return '-';
            return moment(DEADLINE_FREELANCER).format('YYYY-MM-DD');
        }
        },
        {headerName: 'Profile Received', field: 'PROFILE_RECEIVED',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {PROFILE_RECEIVED} = data;
            if (!PROFILE_RECEIVED) return '-';
            return moment(PROFILE_RECEIVED).format('YYYY-MM-DD');
        }
        },
        {headerName: 'Permission Request', field: 'PERMISSION_REQUEST',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {PERMISSION_REQUEST} = data;
            if (!PERMISSION_REQUEST) return '-';
            return moment(PERMISSION_REQUEST).format('YYYY-MM-DD');
        }
        },
        {headerName: 'Deadline (Arbitrator)', field: 'DEADLINE_ARBITRATOR',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {DEADLINE_ARBITRATOR} = data;
            if (!DEADLINE_ARBITRATOR) return '-';
            return moment(DEADLINE_ARBITRATOR).format('YYYY-MM-DD');
        }
        },
        {headerName: 'Profile Approved', field: 'PROFILE_APPROVED',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {PROFILE_APPROVED} = data;
            if (!PROFILE_APPROVED) return '-';
            return moment(PROFILE_APPROVED).format('YYYY-MM-DD');
        }
        },
        {headerName: 'Status', field: 'STATUS'},
        {headerName: 'Planned Date', field: 'projectStartDate'},
        {headerName: 'Project Start Date', field: 'projectStartDate'},
        {headerName: 'Freelancer Chase Date', field: 'freelancerChaseDate'},
        {
            headerName: "Reminder",
            columnGroupShow: 'open',
            children: [
        {headerName: 'Reminder', field: 'ARBITRATOR_REMINDER'},
        {headerName: 'Sent On', field: 'ARBITRATOR_REMINDER_AT',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {ARBITRATOR_REMINDER_AT} = data;
            if (!ARBITRATOR_REMINDER_AT) return '-';
            return moment(ARBITRATOR_REMINDER_AT).format('YYYY-MM-DD');
        }
        },
        ]},
        // {
        //     headerName: "Freelancer's Last Reminder",
        //     columnGroupShow: 'open',
        //     children: [
        // {headerName: 'Reminder', field: 'FREELANCER_REMINDER'},
        // {headerName: 'Sent On', field: 'FREELANCER_REMINDER_AT',
        // valueGetter: ({data}) => {
        //     if (!data) return '';
        //     const {FREELANCER_REMINDER_AT} = data;
        //     if (!FREELANCER_REMINDER_AT) return '-';
        //     return moment(FREELANCER_REMINDER_AT).format('YYYY-MM-DD');
        // }
        // },
        // ]},
        {
            headerName: 'Others Info',
            children: [
        {headerName: 'Notes 1', field: 'notes'},
        {headerName: 'Notes 2', field: 'note1'},
        {headerName: 'Notes 3', field: 'note2'},
        // {headerName: 'Profile Approved Mail Sent', field: 'profile_approved_mail_sent_at'},
        {headerName: 'Workflow', field: 'GLOBAL_WORKFLOW_NAME', columnGroupShow: 'open'},
        {headerName: 'Vendor', field: 'vendor', columnGroupShow: 'open',
        // valueGetter: ({ data }) => {
        //     if (!data) return '';
        //     return data.vendor == 'PubKit' ? 'PubKit' : 'LAPS';
        //     },
        },
        // {headerName: 'Laps Id', field: 'lapsId', columnGroupShow: 'open'},
        // {headerName: 'Laps Message', field: 'lapsMessage', columnGroupShow: 'open'},
        {headerName: 'Arbitrator', field: 'authorNames', columnGroupShow: 'open'},
        {headerName: 'Arbitrator Email', field: 'authorEmails', columnGroupShow: 'open'},
        {headerName: 'CM', field: 'cmNames', columnGroupShow: 'open'},
        {headerName: 'CM Email', field: 'cmEmails', columnGroupShow: 'open'},
        {headerName: 'Freelancer', field: 'freelancerNames', columnGroupShow: 'open'},
        {headerName: 'Freelancer Email', field: 'freelancerEmails', columnGroupShow: 'open'},
        //{headerName: 'Recycle Period', field: 'recyclePeriod', columnGroupShow: 'open'},
       
    ]},
     ];
    editorColumns = [
        {headerName: 'Publication', field: 'abbreviation', pinned: 'left'},
        {headerName: 'Document', field: 'publication', pinned: 'left'},
        {headerName: 'Category', field: 'category'},
        {headerName: 'Author', field: 'author'},
        {headerName: 'Editor', field: 'editor'},
        {headerName: 'CM', field: 'cm'},
        {headerName: 'Editor Review', field: 'editorReviewDate'},
        {headerName: 'Author Query', field: 'authorQuery'},
        {headerName: 'Editor Approved', field: 'editorApproved'},
        {
            headerName: 'Files',
            children: [
                {
                    headerName: 'Sent',
                    field: 'filesSent',
                },
                {
                    headerName: 'Received',
                    field: 'filesReceived'
                },
            ]
        },
        {headerName: 'Status', field: 'status', cellStyle: params => ({color: params.data.statusColor})},
        {headerName: 'Author Comments', field: 'comments'},
    ];

    get columnDefs() {
        if(this.activeFilter=="awaiting")
        {
            return this.awaitingColumns;
        }
        else if(this.activeFilter == "planned")
        {
            return this.plannedColumns;
        }
        else if(this.activeFilter == "in")
        {
            return this.inColumns;
        }
        else if(this.activeFilter == "donotchase")
        {
            return this.doNotChaseColumns;
        }
        else if(this.activeFilter == "all")
        {
            return this.cmColumns;
        }
        else if(this.activeFilter == "SummaryTable")
        {
            return this.summaryColumns;
        }
        // return appStore.credentials.user_type == 'editor'
        //     ? this.editorColumns
        //     : this.cmColumns;
    }
   
    getFormDefs = () => {
        const data = this.currentData;
        const dt =pmFormDefs(data);
        if(data.stage=="In Acquisition")
        {   
            dt[3].disabled = true;
            dt[8].disabled = true;
            dt[9].disabled = true;
            dt[10].disabled = true;
            dt[11].disabled = true;
            dt[12].disabled = true;
            dt[13].disabled = true;
            dt[14].disabled = true;
            dt[15].disabled = true;
            dt[16].disabled = true;
            dt[17].disabled = true;
            dt[18].disabled = true;
            dt[19].disabled = true;
            
        }
        if (appStore.isLooseLeafPm()) return dt;
        //  return appStore.credentials.user_type === 'editor'
        //     ? editorFormDefs(data)
        //     : cmFormDefs(data);
            return appStore.credentials.user_type === 'editor'
            ? editorFormDefs(data)
            : dt;
    };
   
  
    @action nextTab = () => {
        if (this.activeTab == "0") {
            this.activeTab = "1";
        } else if (this.activeTab == "1") {
            this.activeTab = "2";
        } else {
            this.drawerVisible = false;
            this.activeTab = "0";
        }
    };
    @action createItem = async (data)=>{
        let params = {
            ...this.currentData,
            ...data,
        };
        params.country = this.getCountryName;
        params.createdBy = 'CHASER_EMAIL';
        params.projectId = -1;
        params.updatedBy = appStore.credentials.userId;
        const seed = await this.apiProxy.asyncPost(endpoints.createArbitratorSeedUrl, params);
        this.currentData = await seed.json();
        this.currentData.authorNames =this.currentData.authorNames;
        this.currentData.authorEmails = this.currentData.authorEmails;
        this.currentData.freelancerNames = this.currentData.freelancerNames;
        this.currentData.freelancerEmails = this.currentData.freelancerEmails;
        this.currentData.cmNames = this.currentData.cmNames;
        this.currentData.cmEmails = this.currentData.cmEmails;
        await this.fetchData();
        await this.nextTab();
        this.formLoading = false;
    }
  
    @action updateItem = async (data) => {
        if(this.currentData.id == undefined)
        {
            this.createItem(data);
            return false;
        }
        let params = {
            ...this.currentData,
            ...data,
        };
        params.country = this.getCountryName;
        params.updatedBy = appStore.credentials.userId;
        try {
            const response = await this.apiProxy.asyncPost(endpoints.updateArbitratorAttributesUrl, params);
            this.currentData = await params;
            this.currentData.authorNames =params.authorNames;
            this.currentData.authorEmails = params.authorEmails;
            this.currentData.freelancerNames = params.freelancerNames;
            this.currentData.freelancerEmails = params.freelancerEmails;
            this.currentData.cmNames = params.cmNames;
            this.currentData.cmEmails = params.cmEmails;
            
            const data = await response.json();
            this.nextTab();
            this.fixStage(data);
            // this.unfocus();
            // message.success('Loose leaf updated');
            return false;
        } catch (e) {
            message.error('Unable to update data');
            return false;
        }
    };
    @action clickCustomFilter = async (filterValue) =>{
        this.activeFilter = filterValue;
        let tempRowData = [];
            for(let i=0; i<this.currentTable.length; i++)
            {
                if(filterValue == 'in' && this.currentTable[i].stage=='In Acquisition')
                {
                        tempRowData.push(this.currentTable[i]);
                }
                else if(filterValue == 'awaiting' && this.currentTable[i].stage=='Awaiting Acquisition')
                {
                    tempRowData.push(this.currentTable[i]);
                }
                else if(filterValue == 'planned' && this.currentTable[i].stage=='Planned Acquisition')
                {
                    tempRowData.push(this.currentTable[i]);
                }
                else if(filterValue == 'donotchase' && this.currentTable[i].stage=='Do Not Chase')
                {
                    tempRowData.push(this.currentTable[i]);
                }
                else if(filterValue == 'all')
                {
                    tempRowData.push(this.currentTable[i]);
                }
              
            }
            
            this.rowData = tempRowData;
           // this.getSummaryData();
     }
     @action getSummaryData = async()=>{
        this.activeFilter = 'SummaryTable';
         let totalMonograph =[];
         let flags = [];
         let summaryRows=[];
        for(let i=0; i<this.currentTable.length; i++) {
            if(flags[this.currentTable[i].abbreviation]) continue;
            flags[this.currentTable[i].abbreviation] = true;
            totalMonograph.push(this.currentTable[i].abbreviation);
        }
     
        
        for(let i=0; i<totalMonograph.length; i++)
        {
           let total = this.currentTable.filter(function(element) { return (element.abbreviation == totalMonograph[i])});
           let awaitingAcquisition = this.currentTable.filter(function(element) { return (element.abbreviation == totalMonograph[i] && element.stage == "Awaiting Acquisition")});
           let plannedAcquisition = this.currentTable.filter(function(element) { return (element.abbreviation == totalMonograph[i] && element.stage == "Planned Acquisition")});
           let inAcquisition = this.currentTable.filter(function(element) { return (element.abbreviation == totalMonograph[i] && element.stage == "In Acquisition")});
           let doNotChase = this.currentTable.filter(function(element) { return (element.abbreviation == totalMonograph[i] && element.stage == "Do Not Chase")});
           summaryRows.push({
                id:(i),
                rowno:(i+1),
                abbreviation:totalMonograph[i],
                totalMonograph:total.length,
                awaitingAcquisition:awaitingAcquisition.length,
                plannedAcquisition:plannedAcquisition.length,
                inAcquisition:inAcquisition.length,
                doNotChase:doNotChase.length
           })
        }
        this.rowData = summaryRows;
     
    }
     mapToWorkdays=async(date, add)=> {
        const wd = this.weekday(date)
        
        let r = Math.trunc(add / 5) * 2
        const rem = add % 5
      
        if (wd > 4) r += (6-wd)
        else if (wd+rem > 4) r += 2
        
        return add + r;
      }
      weekday=(date)=> { return (date.getUTCDay()+ 6) % 7 }
   
    @action fetchData = async () => {
        this.setLoading(true);
        try {
            const params = {
                userEmail: appStore.credentials.email,
                userType: appStore.credentials.user_type
            };
            const url = endpoints.arbitratordashboardDataUrl;
            const response = await this.apiProxy.getAsync(url);
            const data = await response.json();
            // console.log("Dashboard");
            // console.log(data);
            const mipDates = {"3157":20, "3132":20, "3142":16, "2655":16}
            if(data.status!=500)
            {
                for(let i=0; i<data.length; i++)
                {
                    //for MIP only projectStartDate must be based on workflows
                    //Author Saravanan K
                    //data[i]['projectStartDateCopy'] = data[i]['projectStartDate'];
                    // if(data[i]['abbreviation'] == 'MIP')
                    // {
                    //     if((data[i]['globalWorkflowId']!==undefined) && (mipDates[data[i]['globalWorkflowId']]!==undefined))
                    //     {
                    //         data[i]['projectStartDateCopy'] = moment(data[i]['projectStartDate'], "DD-MM-YYYY").weekday(mipDates[data[i]['globalWorkflowId']], 'days');
                    //     }
                    //     else
                    //     {
                    //         data[i]['projectStartDateCopy'] = moment(data[i]['projectStartDate'], "DD-MM-YYYY").weekday(20, 'days');
                    //     }
                    // }
                    data[i].rowno = (i+1)+' +';
                    // data[i].action = 'Copy';
                    var workflowName = data[i].workflow+"";
                    workflowName = workflowName.toLowerCase();
                    workflowName = workflowName.replace(/ /g,"");
                    workflowName = workflowName.replace(/-/g,"");
                    if(workflowName.match("withprereview"))
                    {
                        data[i].preReview = true;
                    }
                    if(workflowName.match("noprereview"))
                    {
                        data[i].preReview = false;
                    }
                   
                    if(data[i].preReview == true )
                    {
                        data[i].preReview = 'Yes';   
                    }
                    else if(data[i].preReview == false )
                    {
                        data[i].preReview = 'No';
                    }
                    else
                    {
                        data[i].preReview = null;
                    }
                    
                    if(data[i].projectId > 0 && data[i].holdStatus=='true')
                    {
                        data[i].stage = 'Do Not Chase';
                    }
                    else if(data[i].projectId > 0 && data[i].doNotChase != true)
                    {
                       data[i].stage = 'In Acquisition';
                    }
                    else if(data[i].projectStartDate != null && data[i].projectId == -1 && data[i].doNotChase != true)
                    {
                        data[i].stage = 'Planned Acquisition';
                    }
                    else if(data[i].doNotChase==true)
                    {
                        data[i].stage = 'Do Not Chase';
                    }
                    else
                    {
                       data[i].stage = 'Awaiting Acquisition';
                    }
                  
                    var dbStatus = data[i].STATUS;
                    if(dbStatus != "Do Not chase")
                    {
                        if(data[i].ARBITRATOR_REMINDER == "Escalation Arbitrator Permission Request")
                        {
                            data[i].STATUS = 'Escalated';   
                        }
						if(dbStatus == "Permission Request pending") {
							data[i].STATUS = dbStatus;
							if(data[i].ARBITRATOR_REMINDER == "Escalation Arbitrator Permission Request")
							{
								data[i].STATUS = 'Escalated';
							}
						}

						if(data[i].ARBITRATOR_REMINDER == "Escalation Arbitrator Update Request")
                        {
                            data[i].STATUS = 'Escalated';   
                        }
						if(dbStatus == "Permission Request pending") {
							data[i].STATUS = dbStatus;
							if(data[i].ARBITRATOR_REMINDER == "Escalation Arbitrator Update Request ")
							{
								data[i].STATUS = 'Escalated';
							}
						}

						 if(data[i].FREELANCER_REMINDER == "Escalation Freelancer Work Request")
                        {
                            data[i].STATUS = 'Escalated';   
                        }
						if(dbStatus == "Work Request pending") 
                        {
							data[i].STATUS = dbStatus;
							if(data[i].FREELANCER_REMINDER == "Escalation Freelancer Work Request" )
							{
								data[i].STATUS = 'Escalated';   
							}
						}
                        
                        if(data[i].FREELANCER_REMINDER == "Escalation Arbitrator Update Request")
                        {
                            data[i].STATUS = 'Escalated';   
                        }
                        
                        if((data[i].INTEREST_PERMISSION_STATUS == "Permission retracted" ||
                            data[i].INTEREST_PERMISSION_STATUS == "Permission denied" || 
                            data[i].INTEREST_PERMISSION_STATUS == "Arbitrator Deceased"))
                        {
                            data[i].STATUS = dbStatus;
                        }
                     }

                    if(dbStatus == "Do Not chase" || dbStatus == "Do not chase")
                    {
                        data[i].STATUS = "Do Not chase";
                    }
                    
                    if(data[i]["currentTaskAbstractTaskId"]==1350)
                    {
                        data[i]["ARBITRATOR_REMINDER_AT"] = data[i]["FREELANCER_REMINDER_AT"];
                        data[i]["ARBITRATOR_REMINDER"] = data[i]["FREELANCER_REMINDER"];
                    }
                    if(data[i]["currentTaskAbstractTaskId"]==1349)
                    {
                        data[i]["ARBITRATOR_REMINDER"] = data[i]["ARBITRATOR_REMINDER"];
                    }
                    if(data[i]["currentTaskAbstractTaskId"]==1351)
                    {
                        if ((data[i].ARBITRATOR_REMINDER == "Reminder 1") || (data[i].ARBITRATOR_REMINDER == "Reminder 2") || (data[i].ARBITRATOR_REMINDER == "Reminder 3") ) 
                        {
                        data[i]["ARBITRATOR_REMINDER"] = "Arbitrator "+data[i]["ARBITRATOR_REMINDER"];
                        }
                        else
                        {
                            data[i]["ARBITRATOR_REMINDER"] = data[i]["ARBITRATOR_REMINDER"];
                        }
                    }
                    if(data[i]["abstractTaskId"]==1351 && data[i]["currentTaskAbstractTaskId"]==504)
                    {
                        if ((data[i].ARBITRATOR_REMINDER == "Reminder 1") || (data[i].ARBITRATOR_REMINDER == "Reminder 2") || (data[i].ARBITRATOR_REMINDER == "Reminder 3") ) 
                        {
                        data[i]["ARBITRATOR_REMINDER"] = "Arbitrator "+data[i]["ARBITRATOR_REMINDER"];
                        }
                    }
                    if(data[i]["abstractTaskId"]==1349 && data[i]["currentTaskAbstractTaskId"]==504)
                    {
                        if ((data[i].ARBITRATOR_REMINDER == "Reminder 1") || (data[i].ARBITRATOR_REMINDER == "Reminder 2") || (data[i].ARBITRATOR_REMINDER == "Reminder 3") ) 
                        {
                        data[i]["ARBITRATOR_REMINDER"] = data[i]["ARBITRATOR_REMINDER"];
                        }
                    }
                   
          }                
             this.currentTable = data;
             this.clickCustomFilter(this.activeFilter);
            //  this.rowData = data;
            }
          
        } catch (e) {
            message.error('Failed to fetch data');
            console.error(e);
        }
        this.setLoading(false);
    };

    flattenData = async(response) => {
          var rowData = [];
          console.log(response);
          Object.keys(response).forEach(publication => {
          const datalist = response[publication];
          datalist.forEach(dt => {
            rowData.push({
                id: dt.id,
                titleId: dt.titleId,
                classification: dt.classification,
                lapsId: dt.lapsId,
                vendor: dt.vendor,
                globalWorkflowId: dt.globalWorkflowId,
                recyclePeriod: dt.recyclePeriod,
                projectStartDate: dt.projectStartDate,
                freelancerChaseDate: dt.freelancerChaseDate,
                GLOBAL_WORKFLOW_NAME: dt.GLOBAL_WORKFLOW_NAME,
                doNotChase: dt.doNotChase,
                wip_cmNames: dt.wip_cmNames,
                wip_cmEmails: dt.wip_cmEmails,
                wip_authorNames: dt.wip_authorNames,
                wip_authorEmails: dt.wip_authorEmails,
                wip_freelancerNames: dt.wip_freelancerNames,
                wip_freelancerEmails: dt.wip_freelancerEmails,
                projectId: dt.projectId,
                authorNames: dt.authorNames,
                authorEmails: dt.authorEmails,
                freelancerNames: dt.freelancerNames,
                freelancerEmails: dt.freelancerEmails,
                cmNames: dt.cmNames,
                cmEmails: dt.cmEmails,
                productType: dt.productType,
                INTEREST_PERMISSION_STATUS: dt.INTEREST_PERMISSION_STATUS,
                INTEREST_PERMISSION_DATE: dt.INTEREST_PERMISSION_DATE,
                INTEREST_REQUEST: dt.INTEREST_REQUEST,
                WORK_REQUEST: dt.WORK_REQUEST,
                DEADLINE_FREELANCER: dt.DEADLINE_FREELANCER,
                PROFILE_RECEIVED: dt.PROFILE_RECEIVED,
                PERMISSION_REQUEST: dt.PERMISSION_REQUEST,
                DEADLINE_ARBITRATOR: dt.DEADLINE_ARBITRATOR,
                PROFILE_APPROVED: dt.PROFILE_APPROVED,
                STATUS: dt.STATUS,
                ARBITRATOR_REMINDER_AT: dt.ARBITRATOR_REMINDER_AT,
                ARBITRATOR_REMINDER: dt.ARBITRATOR_REMINDER,
                FREELANCER_REMINDER_AT: dt.FREELANCER_REMINDER_AT,
                FREELANCER_REMINDER: dt.FREELANCER_REMINDER,
                holdStatus: dt.holdStatus,
                countryId: dt.countryId,
                country : dt.country ,
                notes: dt.notes,
                note1: dt.note1,
                note2: dt.note2,
                currentTaskAbstractTaskId: dt.currentTaskAbstractTaskId,
                abstractTaskId:dt.abstractTaskId
            });
          });
        });
        if(rowData.length == 0) return [{id: "No data"}]
        return rowData;
      };

    @action setCurrentData = (data) => {
        this.currentData = data;
        this.drawerVisible = true;
    };
    @action setCreateData = visible => {
        this.currentData = '';
        this.drawerVisible = visible;
        this.activeTab = '0';
    };
    @action unfocus = () => {
        this.drawerVisible = false;
        this.currentData = {};
    };

    @action deleteLooseLeaf = async(item) => {
        item.deletedBy = appStore.credentials.userId;
        item.deletedAt =  new Date().toISOString().slice(0, 19).replace('T', ' ');
        const response = await this.apiProxy.asyncPost(endpoints.updateArbitratorAttributesUrl, item);
        const data = await response.json();
        this.fixStage(data);
    }
    @action fixStage = (data) =>{
        if(data.status!=500)
        {
            for(let i=0; i<data.length; i++)
            {
                data[i].rowno = (i+1)+' +';
                // data[i].action = 'Copy';
                var workflowName = data[i].workflow+"";
                workflowName = workflowName.toLowerCase();
                workflowName = workflowName.replace(/ /g,"");
                workflowName = workflowName.replace(/-/g,"");
                if(workflowName.match("withprereview"))
                {
                    data[i].preReview = true;
                }
                if(workflowName.match("noprereview"))
                {
                    data[i].preReview = false;
                }
                if(data[i].preReview == true )
                {
                    data[i].preReview = 'Yes';   
                }
                else if(data[i].preReview == false )
                {
                    data[i].preReview = 'No';
                }
                else
                {
                    data[i].preReview = null;
                }
                if(data[i].projectId > 0 && data[i].holdStatus=='true')
                {
                    data[i].stage = 'Do Not Chase';
                }
                else if(data[i].projectId > 0 && data[i].doNotChase != true)
                {
                   data[i].stage = 'In Acquisition';
                }
                else if(data[i].projectStartDate != null && data[i].projectId == -1 && data[i].doNotChase != true)
                {
                    data[i].stage = 'Planned Acquisition';
                }
                else if(data[i].doNotChase==true)
                {
                    data[i].stage = 'Do Not Chase';
                }
                else
                {
                   data[i].stage = 'Awaiting Acquisition';
                }
            }   
            this.currentTable = data;
            this.clickCustomFilter(this.activeFilter);
            // this.rowData = data;
        }
        else
        {
            message.error('Failed to fetch data');
            console.error(e);
        }

       
    }
}

export default new DashboardArbitratorStore();